import { CalendarBlank } from "phosphor-react";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SolidButton } from "../../global/SolidButton";
import { Filter } from "lucide-react";
import MyLoader from "../../util/MyLoader";
import { getAppSources, getAppTransactions } from "./api";
import { MyCalModel } from "../../global/MyCalModel";
import Pagination from "../../util/Pagination";
import { MyModal } from "../../global/MyModal";

import DatePicker from "react-datepicker";
import toast from "react-hot-toast";

export default function Transactions() {
  const type = [
    { id: 1, label: "All", value: "ALL" },
    { id: 2, label: "Success", value: "SUCCESS" },
    { id: 3, label: "Pending", value: "PENDING" },
    { id: 4, label: "Failed", value: "FAILED" },
  ];
  const [activeTab, setActiveTab] = useState(1);

  const navigate = useNavigate();
  const { id } = useParams();
  const handleTabClick = (tabId) => {
    const selectedTab = type.find((item) => item.id === tabId);

    if (!selectedTab) return;

    navigate(`/apps/${id}/transactions?status=${selectedTab.value}`);
    setActiveTab(tabId);
  };

  const [isOpenCal, setIsOpenCal] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userId, setUserID] = useState(null);
  const [service, setService] = useState("all");
  const [sources, setSources] = useState([]);


  // actual applied value
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const setDateRange = (update) => {
    const [start, end] = update;
    setStartDate(start);
    setEndDate(end);
  };

  // pagination state

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(30);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");


  const getTransactions = async () => {
    const payload = {
      page: page,
      limit: limit,
      search: appliedSearch,
      user_id: userId,
      dateFrom: startDate,
      dateTo: endDate,
      service:service,
      status: type[activeTab - 1].value,
    };
    try {
      const response = await getAppTransactions(payload);
      if (response.status === 200) {
        const data = response?.data;
        setTransactions(data?.transactions || []);
        setTotal(data?.total);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };
  const getServices = async () => {
    try {
      const response = await getAppSources();
      if (response.status === 200) {
        const data = response?.data;
        setSources(data || []);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  const getTransByDate = async () => {
    getTransactions();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getTransactions();
    }, 400);

    return () => clearTimeout(timer);
  }, [activeTab, page, limit,appliedSearch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      getServices();
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  const applyFilter = async () => {
    setPage(1);
    
    getTransactions();
    setIsModalOpen(false);
  };

  //Search
  useEffect(() => {
    if (search.endsWith(" ")) {
      setPage(1);
    }
  }, [search]);

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-4 w-full flex flex-col">
        <div className="flex items-center justify-between h-auto  space-x-2 md:space-x-4">
          {/* tabs */}
          <div className=" flex items-center justify-between">
            <div className="flex items-center gap-2 px-2 py-2 bg-slate-300/25 dark:bg-slate-900/80 backdrop-blur-xl rounded-lg">
              {type.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`text-xs px-3 py-1.5 rounded-md transition-all duration-200 
        ${
          tab.id === activeTab
            ? "bg-white dark:bg-slate-800 text-black dark:text-white shadow-sm"
            : "text-slate-600 dark:text-slate-400 hover:bg-white/50 dark:hover:bg-slate-800/50"
        }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          {/* Search */}
          <div className="ml-auto w-full md:w-50 mr-0">
            <input
              type="search"
              placeholder="Search by order id..."
                 value={search}
                 onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                          setPage(1);
                          setAppliedSearch(search.trim());
                }
              }}
              className=" text-xs py-1.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            />
          </div>
          {/* date picker */}
          <div
            onClick={() => setIsOpenCal(true)}
            className="flex items-center justify-start text-xs border rounded-lg 
          mr-8 dark:border-slate-400 border-slate-300 px-2 py-1.5 space-x-2 "
          >
            <CalendarBlank
              size={18}
              className="text-slate-600 dark:text-slate-400 "
            />
            <span className="text-slate-600 dark:text-slate-400 line-clamp-1">
              Pick date range
            </span>
          </div>
          {/* filter */}
          <SolidButton
            className="py-1 h-[30px]   px-2   "
            onClick={() => setIsModalOpen(true)}
          >
            <Filter size={14} />
            <span>Filter</span>
          </SolidButton>
        </div>
        {/* table */}
        <div className="flex-1 overflow-auto mt-4">
          <div
            className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
               overflow-x-auto       
               mt-4 
              "
          >
            <div className="overflow-x-auto">
              <table className="w-full text-xs text-left">
                <thead>
                  <tr className="border-b border-slate-300/40 text-slate-600 dark:text-slate-400">
                    <th className="px-4 py-3 font-semibold text-start space-x-2">
                      Transaction
                    </th>
                    <th className=" py-3 font-semibold text-start">User</th>

                    <th className=" py-3 font-semibold text-start">
                      Bonus Coins
                    </th>
                    <th className=" py-3 font-semibold text-start">Source</th>
                    <th className=" py-3 font-semibold text-start">Status</th>
                    <th className="py-3 font-semibold text-start">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((transaction, index) => (
                    <tr
                      key={index}
                      className="border-b border-slate-300/40 text-start text-xs text-slate-700 dark:text-slate-300"
                    >
                      <td className="px-4 py-3 ">
                        <div
                          onClick={() =>
                            navigate(
                              `/apps/${id}/transactions/${transaction.user_id}`,
                              { state: { username: transaction.name } },
                            )
                          }
                          className="flex flex-col cursor-pointer"
                        >
                          <span className="text-xs text-slate-800 dark:text-slate-200 font-medium">
                            {transaction.message}
                          </span>
                          <span className="text-xs text-slate-600 dark:text-slate-400">
                            {`# ${transaction.id}`}
                          </span>
                        </div>
                      </td>
                      <td
                        onClick={() => {
                          navigate(`/apps/${id}/users/${transaction.user_id}`);
                        }}
                        className=" py-3 flex flex-col cursor-pointer"
                      >
                        <span className="text-xs text-slate-800 dark:text-slate-200 font-medium">
                          {transaction.name}
                        </span>
                        <span className="text-xs text-slate-600 dark:text-slate-400">
                          {transaction.joined_at}
                        </span>
                      </td>

                      <td
                        className={` py-3 ${transaction.event === "WITHDRAW" ? "text-red-500" : "text-green-400"} font-medium`}
                      >
                        {transaction.event === "WITHDRAW"
                          ? "-" + transaction.coins
                          : transaction.coins}
                      </td>
                      <td className=" py-3">{transaction.event}</td>
                      <td className=" py-3 text-green-600  font-semibold">
                        <span className="bg-green-500/20 rounded-2xl py-1 px-2">
                          Success
                        </span>
                      </td>

                      <td className=" py-3 ">
                        <div>
                          <span className="text-slate-600 dark:text-slate-300">
                            {transaction.created_at}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="sticky bottom-0 bg-white dark:bg-slate-900 my-2">
          <Pagination
            page={page}
            limit={limit}
            total={total}
            fixed={false}
            onPageChange={setPage}
            onLimitChange={(l) => {
              setLimit(l);
              setPage(1); // reset to first page
            }}
            constrainTo="#devices-main"
          />
        </div>
      </div>
      {/* Date Range */}
      <MyModal
        // title={"Transaction Filters"}
        isOpen={isOpenCal}
        //  onClose={() => setIsOpenCal(false)}
        width="560px"
      >
        <div className="space-y-2 w-full ">
          <div className="flex items-center justify-center">
            <DatePicker
             // selected={startDate}
               showPopperArrow={false}
                shouldCloseOnSelect={false}
              onChange={(update) => {
                const [start, end] = update || [];

                const startDateFixed = start
                  ? new Date(
                      start.getFullYear(),
                      start.getMonth(),
                      start.getDate(),
                      0,
                      0,
                      0,
                      0,
                    )
                  : null;

                const endDateFixed = end
                  ? new Date(
                      end.getFullYear(),
                      end.getMonth(),
                      end.getDate(),
                      23,
                      59,
                      59,
                      999,
                    )
                  : null;

                setDateRange([startDateFixed, endDateFixed]);

                console.log("fromDate", startDateFixed?.toISOString());
                console.log("toDate", endDateFixed?.toISOString());
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              inline
              maxDate={new Date()}
              monthsShown={2}
              calendarClassName="  !shadow-xl !bg-slate-200 dark:!bg-slate-600 !flex"
            />
          </div>

          <div className="flex items-center justify-center space-x-4">
            <button
              className="px-4 py-2 rounded-lg text-xs
                                        bg-slate-400/20 dark:bg-slate-800 
                                        text-slate-800 dark:text-slate-300  font-semibold
                                        hover:bg-slate-400/30 dark:hover:bg-slate-700 
                                        transition-all duration-300 ml-auto"
              onClick={() => {
                setDateRange(["", ""]);
              }}
            >
              Clear
            </button>
            <SolidButton
              children={<span className="text-xs">Apply</span>}
              onClick={() => {
                if (startDate && !endDate) {
                  toast.success("select end date");
                } else {
                  setIsOpenCal(false);
                  getTransByDate();
                }
              }}
            />
          </div>
        </div>
      </MyModal>

      {/* Filter */}
      <MyModal
        title={"Transaction Filters"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="460px"
      >
        <div className="space-y-2 w-full">
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              User Id*
            </label>

            {/* Input */}
            <input
              type="number"
              placeholder="E.g. 1233"
              value={userId}
              onChange={(e) => setUserID(e.target.value)}
              className="w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
            />
          </div>
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Service*
            </label>

            <select
              name="sortBy"
              value={service}
              //  defaultValue={"razorpay"}

              onChange={(e) => {
                setService(e.target.value);
              }}
              placeholder="Service"
              id=""
              className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border  
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${"border-slate-200 dark:border-slate-700"}`}
            >
              <option value="All">All</option>
              {sources.map((source, index) => (
                <option key={index} value={source}>
                  {source}
                </option>
              ))}
            </select>
          </div>
          <div className="bg-slate-500/20 dark:bg-slate-400/20  w-full h-[1px] mt-4" />
          <div className="flex items-center justify-between space-x-4 mt-4 ml-auto">
            <span
              onClick={() => {
                setService("All");
                setUserID("");
              }}
              className="dark:text-slate-400 text-slate-500 text-xs cursor-pointer py-2 pr-2"
            >
              Reset
            </span>
            <button
              className="px-4 py-2 rounded-lg
                      bg-slate-400/20 dark:bg-slate-800 
                      text-slate-800 dark:text-slate-300 text-sm font-semibold
                      hover:bg-slate-400/30 dark:hover:bg-slate-700 
                      transition-all duration-300 ml-auto"
              onClick={() => {
                setIsModalOpen(false);
                // setErrors({});
              }}
            >
              Cancel
            </button>
            <SolidButton
              children={<span>Apply Filters</span>}
              onClick={() => {
                applyFilter();
              }}
            />
          </div>
        </div>
      </MyModal>
    </Fragment>
  );
}


